/* NNM size-upgrade nudge (5 Oct 2026, trees.com build). One rule, two places.
   CART: under every plant line, "The bigger 25L is just $22.00 more. Upgrade" swaps the line for the next size.
   PRODUCT PAGE: under the size pills, "Next size up: 25L, $22.00 more. Choose it" selects that pill.
   The next size = the smallest size above the chosen one in the product's own ladder (Tube, then mm, then L)
   with the SAME pack quantity ("140mm (Pack of 10)" never upgrades to "200mm (Pack of 6)"), a plain size (no
   Topiary / Standard / Ex Ground forms), in stock, not "(Backorder)", and priced within 40% above the chosen
   size (an equal price counts). Anything else = no nudge. The old snippets/line-item-upsell.liquid (removed
   24 Jul 2026) picked the first dearer variant and ignored stock and packs; this replaces it. */
(function () {
  if (window.__nnmUpsizeInit) return;
  window.__nnmUpsizeInit = true;

  var MAX_RISE = 0.40;        /* next size may cost up to 40% more */
  var cache = {};

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* "140mm (Pack of 10) (Backorder)" -> {base:'140mm', pack:10, bo:true, rank:140, plain:true} */
  function parse(title) {
    var t = String(title || '');
    var bo = /backorder/i.test(t);
    var m = t.match(/pack of (\d+)/i);
    var pack = m ? parseInt(m[1], 10) : 1;
    var base = t.replace(/\s*\(backorder\)/ig, '').replace(/\s*\(pack of \d+\)/ig, '').replace(/\s*-\s*pack of \d+/ig, '').trim();
    var rank = -1, plain = false;
    if (/^tube$/i.test(base)) { rank = 0; plain = true; }
    else if (/^\d+\s*mm$/i.test(base)) { rank = parseInt(base, 10); plain = true; }
    else if (/^\d+(\.\d+)?\s*L$/i.test(base)) { rank = 10000 + parseFloat(base); plain = true; }
    return { base: base, pack: pack, bo: bo, rank: rank, plain: plain };
  }

  function nextSize(product, variantId) {
    if (!product || product.type !== 'Plants & Trees') return null;
    var cur = null;
    product.variants.forEach(function (v) { if (String(v.id) === String(variantId)) cur = v; });
    if (!cur) return null;
    var c = parse(cur.title);
    if (!c.plain || c.bo) return null;
    var best = null, bestP = null;
    product.variants.forEach(function (v) {
      if (v.id === cur.id || !v.available) return;
      var p = parse(v.title);
      if (!p.plain || p.bo || p.pack !== c.pack || p.rank <= c.rank) return;
      if (best && p.rank >= bestP.rank) return;
      best = v; bestP = p;
    });
    if (!best) return null;
    var rise = best.price - cur.price;
    if (rise < 0 || rise > cur.price * MAX_RISE) return null;
    return { variant: best, label: bestP.base, pack: bestP.pack, rise: rise, from: cur };
  }

  function productJSON(handle) {
    if (cache[handle]) return cache[handle];
    var s = null;
    try { s = sessionStorage.getItem('nnmUp:' + handle); } catch (e) {}
    if (s) { try { cache[handle] = Promise.resolve(JSON.parse(s)); return cache[handle]; } catch (e) {} }
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var slim = { type: p.type, variants: p.variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, available: v.available }; }) };
        try { sessionStorage.setItem('nnmUp:' + handle, JSON.stringify(slim)); } catch (e) {}
        return slim;
      })
      .catch(function () { return null; });
    return cache[handle];
  }

  function sentence(n, where) {
    var what = n.label + (n.pack > 1 ? ' pack of ' + n.pack : '');
    if (where === 'cart') {
      return n.rise === 0
        ? 'The bigger <b>' + esc(what) + '</b> is the same price.'
        : 'The bigger <b>' + esc(what) + '</b> is just <b>' + money(n.rise) + '</b> more.';
    }
    return n.rise === 0
      ? 'Next size up: <b>' + esc(what) + '</b>, same price.'
      : 'Next size up: <b>' + esc(what) + '</b>, ' + money(n.rise) + ' more.';
  }

  /* ---------- CART ---------- */
  var cartBusy = false, cartTimer = null;

  function paintCart() {
    var rows = document.querySelectorAll('.cart-item[data-nnm-handle]');
    if (!rows.length) return;
    [].forEach.call(rows, function (row) {
      var slot = row.querySelector('.cart-item__upsell-wrap');
      if (!slot || row.getAttribute('data-nnm-type') !== 'Plants & Trees') return;
      var handle = row.getAttribute('data-nnm-handle'), vid = row.getAttribute('data-variant-id');
      productJSON(handle).then(function (p) {
        var n = nextSize(p, vid);
        var box = slot.querySelector('.nnm-up');
        if (!n) { if (box) box.remove(); return; }
        if (!box) { box = document.createElement('div'); box.className = 'nnm-up'; slot.appendChild(box); }
        box.setAttribute('data-vid', vid);
        box.innerHTML = '<span class="nnm-up__t">' + sentence(n, 'cart') + '</span>'
          + '<button type="button" class="nnm-up__btn" data-next="' + n.variant.id + '" data-key="' + esc(row.getAttribute('data-nnm-key')) + '" data-qty="' + esc(row.getAttribute('data-nnm-qty')) + '">Upgrade</button>';
      });
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.nnm-up__btn');
    if (!b || cartBusy) return;
    cartBusy = true;
    b.disabled = true; b.textContent = 'Upgrading...';
    var key = b.getAttribute('data-key'), next = b.getAttribute('data-next'), qty = parseInt(b.getAttribute('data-qty') || '1', 10) || 1;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = null;
      (cart.items || []).forEach(function (it) { if (it.key === key) line = it; });
      var props = (line && line.properties) || {};
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(next, 10), quantity: qty, properties: props }] }) });
        });
    }).then(function (r) {
      if (!r || !r.ok) throw 0;
      window.location.reload();
    }).catch(function () {
      cartBusy = false; b.disabled = false; b.textContent = 'Upgrade';
    });
  });

  function watchCart() {
    var host = document.getElementById('cart-items');
    if (!host) return;
    paintCart();
    new MutationObserver(function () {
      clearTimeout(cartTimer); cartTimer = setTimeout(paintCart, 150);
    }).observe(host, { childList: true, subtree: true });
  }

  /* ---------- PRODUCT PAGE ---------- */
  function pdpProduct(picker) {
    var s = picker.querySelector('script[type="application/json"]');
    if (!s) return null;
    try { var j = JSON.parse(s.textContent); return j.product || null; } catch (e) { return null; }
  }
  function currentVariantId() {
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"], .js-product-form-main [name="id"]');
    return inp ? inp.value : null;
  }
  function paintPdp() {
    var slot = document.querySelector('[data-nnm-upsize-pdp]');
    var picker = slot && slot.closest('variant-picker');
    if (!slot || !picker) return;
    var p = pdpProduct(picker);
    var n = nextSize(p, currentVariantId());
    if (!n) { slot.hidden = true; slot.innerHTML = ''; return; }
    slot.hidden = false;
    slot.innerHTML = '<span>' + sentence(n, 'pdp') + '</span> <button type="button" class="nnm-up__link" data-title="' + esc(n.variant.title) + '">Choose it</button>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.nnm-up__link');
    if (!b) return;
    var title = b.getAttribute('data-title');
    var radios = document.querySelectorAll('variant-picker input.js-option');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === title) {
        var lab = document.querySelector('label[for="' + radios[i].id + '"]');
        if (lab) lab.click(); else { radios[i].checked = true; radios[i].dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
    }
  });
  function watchPdp() {
    if (!document.querySelector('[data-nnm-upsize-pdp]')) return;
    paintPdp();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('js-option')) setTimeout(paintPdp, 60);
    });
    document.addEventListener('on:variant:change', function () { setTimeout(paintPdp, 60); });
  }

  function init() { watchCart(); watchPdp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
